import React, { useState,useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import axios from 'axios';
import './styles.css';
import MobileMoneyModal from '../mobile_money_modal/Mobile_Modal';
import PaymentSuccessModal from '../paymentStatusModal/PaymentStatusModal';
import useQuery from '../../hooks/useParams';
import PageLoader from '../page_loader/PageLoader';
import OrderSummary from '../order_summary/OrderSummary ';

const override = {
    borderWidth: 8,
    margin: '0 auto'
};

const MultiStepForm = () => {
    let registrationOpen = true
    const query = useQuery();
    const ref = query.get('ref')
    const [pageLoading, setPageLoading] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState(false)
    const [paymentStatusMessage, setPaymentStatusMessage] = useState('')
    const [showMobileMoneyModal, setShowMobileMoneyModal] = useState(false)
    const [momoData, setMomoData] = useState([])
    const [schools, setSchools] = useState([]);
    const [terms,SetTerms] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [showAllergyDetails, setShowAllergyDetails] = useState('no');
    const [formData, setFormData] = useState({
        studentID: '',
        studentName: '',
        studentClass: '',
        studentshool: '',
        studentFoodAllegy: 'None',
        studentSection: '',
        schoolTerm: '',
        parentFullname: '',
        parentEmail: '',
        parentNumber: '',
        paymentType: '',
    });

    const classesBySection = {
        Infant: [
            
            // "Nursery Allamanda",
            // "Nursery Tulip",
            // "Reception Begonia",
            // "Reception Buttercup",
            // "Reception Bluebell",
            // "1 Lily ", "1 Rose",
            // "1 Orchid",
            // "1 Violet",
            // "2 Marigold",
            // "2 Daisy",
            // "2 Salvia",
            // "2 Jasmine",
            "Nursery",
            "Reception",
            "Class 1",
            "Class 2"
        ],
        Junior: [
            // "3 Iroko",
            // "3 Mansonia",
            // "3 Jacaranda",
            // "3 Sapele",
            // "4 Eucalyptus ",
            // "4 Maple",
            // "4 Sequoia",
            // "4 Tamarix",
            // "5 Euptelea",
            // "5 Meranti",
            // "5 Oak",
            // "5 Acacia",
            // "5 Willow ",
            // "6 Baobab ",
            // "6 Mahogany",
            // "6 Flamboyant",
            // "6 Lotus",
            // "6 Rosewood",
            "Class 3",
            "Class 4",
            "Class 5",
            "Class 6"
        ],
        Secondary: [
            "FORM 1P",
            "FORM 1Q",
            "FORM 1X",
            "FORM 1Y",
            "FORM 3Y",
            "FORM 2P",
            "FORM 2Q",
            "FORM 2X",
            "FORM 2Y",
            "FORM 3P",
            "FORM 3Q",
            "FORM 3X",
            "FORM 1ESL",
            "FORM 2ESL",
            "FORM 3ESL",
            "FORM 4ESL",
            "FORM 4L",
            "FORM 4M",
            "FORM 4R",
            "FORM 4S",
            "FORM 5L",
            "FORM 5M",
            "FORM 5R",
            "FORM 5S",
            "LOWER 6L",
            "LOWER 6M",
            "LOWER 6R",
            "UPPER 6L",
            "UPPER 6M",
            "UPPER 6R"
        ]
    }

    const [orderSummaryState, setOrderSummaryState] = useState({});
    const [showOrderSummary, setShowOrderSummary] = useState(false);

    const handleRadioChange = (value) => {
        setShowAllergyDetails(value);
        if (value === 'yes') {
            setFormData({ ...formData, studentFoodAllegy: '' });
        } else {
            setFormData({ ...formData, studentFoodAllegy: 'None' });
            setErrors({ ...errors, studentFoodAllegy: '' });
        }
    };

    const validateForm = () => {
        if (!registrationOpen) {
            alert("Sorry registration is over");
            return;
        }
        const newErrors = {};
        if (!formData.studentID.trim()) newErrors.studentID = 'Student ID is required.';

        if (showAllergyDetails === 'yes' && !formData.studentFoodAllegy.trim()) {
            newErrors.studentFoodAllegy = 'Enter an allergy';
        }

        if (!formData.studentName.trim()) newErrors.studentName = 'Student name is required.';
        if (!formData.studentClass.trim()) newErrors.studentClass = 'Student class is required.';
        if (!formData.studentshool.trim()) newErrors.studentshool = 'Select School';
        if (!formData.studentSection.trim()) newErrors.studentSection = 'Select academic section';
        if (!formData.schoolTerm.trim()) newErrors.schoolTerm = 'Select a terem';
        if (!formData.parentFullname.trim()) newErrors.parentFullname = 'Parent name is required';
        if (!formData.parentEmail.trim()) newErrors.parentEmail = 'Parent Email is required';
        if (!formData.parentNumber.trim()){
            newErrors.parentNumber = 'Parent number is required';
            alert("Enter a valid number")
        }else if(formData.parentNumber.length < 10 || formData.parentNumber.length > 10){
            newErrors.parentNumber = 'Enter a valid number';
            alert("Enter a valid number")
        }
        if (!formData.paymentType.trim()) newErrors.paymentType = 'Select payment type';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        if (name === "studentSection") {
            console.log('value => ', value)
        }

        if (name === 'studentFoodAllergy' && showAllergyDetails === 'yes' && !value.trim()) {
            setErrors({ ...errors, studentFoodAllegy: 'Enter an allergy' });
        } else {
            setErrors({ ...errors, studentFoodAllegy: '' });
        }
        console.log('name => ', name)
    };


    const handleSchoolChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });

        if (value) {
            const selectedSchoolData = schools.find((school, index) => index.toString() === value);

            if (selectedSchoolData) {
                const liveUrl = `https://web-production-d558.up.railway.app/api/get-school-term?ch_price_type=${selectedSchoolData.ch_price_type}`
                // const testUrl = `https://web-production-d558.up.railway.app/api/get-school-term?ch_price_type=${selectedSchoolData.ch_price_type}`;
    
                fetch(liveUrl)
                    .then(response => response.json())
                    .then(data => {
                        console.log(data.items);
                        SetTerms(data.items);
                    })
                    .catch(error => console.error('Error fetching terms:', error));
            } else {
                SetTerms([]);
            }
        }
    };
    


    const handleSubmit = async (e)  => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true);

            if (formData.paymentType === 'Card Payment') {
                const selectedSchool = schools.find((school,index) => index.toString() === formData.studentshool);
                const selectedTerm = terms.find((term,index) => index.toString() === formData.schoolTerm);

                const finalizedFormState = { 
                    ...formData, 
                    studentshool: selectedSchool.school,
                    schoolTerm: selectedTerm.term,
                    SCHOOLCODE: selectedSchool.nu_customer_code
                };
                const registrationData = {
                    ...finalizedFormState,
                    vc_comp_code: selectedSchool.vc_comp_code,
                    vc_item_code: selectedTerm.vc_item_code
                };

                try {
                    // const testUrl = `https://web-production-d558.up.railway.app/api/authorize-payment`
                    const liveUrl = 'https://web-production-d558.up.railway.app/api/authorize-payment'
                    const  response = await axios.post(
                        liveUrl, {registrationData, selectedSchool,selectedTerm}
                        ,{ timeout: 60000 }
                    );
                    console.log("shubham Response => ",response)

                    if (response.status===200 && response.data.order_reference) {
                        // PUSH THE FORM DATA TO THE TEMP STORAGE
                        const orderRef = response.data.order_reference
                        const liveTempUrl = "https://web-production-d558.up.railway.app/api/temp/registration-records"
                        // const testTempUrl = "https://web-production-d558.up.railway.app/api/temp/registration-records"
                        await axios.post(
                            liveTempUrl, {orderRef,registrationData, selectedSchool,selectedTerm}, {timeout: 500000}
                        ).then(()=>{


                        localStorage.setItem(`${response.data.order_reference}`, JSON.stringify(registrationData));
                        // window.location.href = response.data.pay_url;
                        setOrderSummaryState({
                            paymentType:'Card Payment',
                            payment_link: response.data.pay_url,
                            studentName: formData.studentName,
                            selectedTerm: selectedTerm.term,
                            termAmount: selectedTerm.nu_price,
                            bankCharges:  selectedTerm.bank,
                            totalAmount: (selectedTerm.nu_price + selectedTerm.bank)
                        })

                        setShowOrderSummary(true)
                        })
                    }

                } catch (error) {
                    alert("Something strange happened kindly reload the page and try again"); 
                    console.error('Error initiating payment:', error.response.data); 
                } finally {
                    setLoading(false);
                }
            }else{
                // alert("Mobile Money Coming soon");
                // setLoading(false);
                
                // const testUrl = `https://web-production-d558.up.railway.app/api/mobile-payment-option`
                const liveUrl = 'https://web-production-d558.up.railway.app/api/mobile-payment-option'
                axios.get(liveUrl)
                    .then(response => { 
                        if(response.status===200){
                        const selectedTerm = terms.find((term,index) => index.toString() === formData.schoolTerm)
                        setOrderSummaryState({
                            payment_link: "",
                            studentName: formData.studentName,
                            selectedTerm: selectedTerm.term,
                            termAmount: selectedTerm.nu_price,
                            bankCharges:  selectedTerm.momo,
                            totalAmount: (selectedTerm.nu_price + selectedTerm.momo)
                        })

                        setShowOrderSummary(true)
                        setLoading(false);
                        setMomoData(response.data)
                    }
                    })
                    .catch(error => {
                        alert("Something strange happened kindly reload the page and try again")
                        setLoading(false);
                        console.log('There was an error ',error)
                    })   
                }
        }else{
            console.log(errors)
        }

    };

    useEffect(() => {
         //const testUrl = "https://web-production-d558.up.railway.app/api/get-school-data"
        const liveUrl = 'https://web-production-d558.up.railway.app/api/get-school-data'
        axios.get(liveUrl)
            .then(response => { 
                setSchools(response.data.items);
            })
            .catch(error => {console.log('There was an error ')})
    }, [])

    useEffect(() => {
        const fetchPaymentStatus = async (ref) => {
            if (!ref) return;

            const processedRefs = JSON.parse(localStorage.getItem('processedRefs')) || [];
            
            if (processedRefs.includes(ref)) {
                setPaymentStatus("SUCCESS")
                setPaymentStatusMessage("Payment already made");
                return;
            }

            setPageLoading(true);

            try {
                // const testUrl = `https://web-production-d558.up.railway.app/api/payment-outcome?ref=${ref}`
                const liveUrl = `https://web-production-d558.up.railway.app/api/payment-outcome?ref=${ref}`
                
                const response = await axios.get(liveUrl);
                const data = response.data;
                const registrationData = localStorage.getItem(`${ref}`);

                if (registrationData && data) {
                    try {
                        const registration_data = JSON.parse(registrationData)
                        // const testRegistrationURl = 'https://web-production-d558.up.railway.app/api/registration'
                        const liveRegistrationURL = `https://web-production-d558.up.railway.app/api/registration`
                        const responseFromErp = await axios.post(liveRegistrationURL, {registration_data, paymentRef: ref})
                        if (responseFromErp.status === 200) {
                            localStorage.removeItem(registrationData);
                        }
                    } catch (error) {
                        console.error('Error saving registration data:', error.data.message);
                    }
                }
                console.log('data information from registrations =>',data);
                // BASE ON THE PAYMENT STATUSE THE APPRIATE MESSAGE HOW BE SHOWN ON THE STATUS MODAL
                setPageLoading(false);
                setPaymentStatus(data.order_status);
                // setPaymentStatusMessage(data.order_text_summary.summaryText);

                processedRefs.push(ref);
                localStorage.setItem('processedRefs', JSON.stringify(processedRefs))

            } catch (error) {
                console.error('Error fetching payment status:', error);
            }
        };

        fetchPaymentStatus(ref);
    }, [ref]); 

    return (
        <div className="container" id="mealRegistration">
            {
                showMobileMoneyModal && momoData && (
                    <MobileMoneyModal 
                        show={showMobileMoneyModal}
                        onClose={() => setShowMobileMoneyModal(false)}
                        data={momoData}
                        registrationData={formData}
                        selectedSchool={schools.find((school,index) => index.toString() === formData.studentshool)}
                        selectedTerm ={terms.find((term,index) => index.toString() === formData.schoolTerm)}
                        setPaymentStatus={setPaymentStatus}
                    />
                )
            }

            <PaymentSuccessModal 
                isOpen={paymentStatus}
                onClose={setPaymentStatus}
                status={paymentStatus}
                message={paymentStatusMessage}
            />


            <OrderSummary 
                show={showOrderSummary}
                setShowOrderSummary={setShowOrderSummary}
                data={orderSummaryState}
                setShowMobileMoneyModal={setShowMobileMoneyModal}
                paymentType={formData.paymentType}
            />

            { pageLoading && <PageLoader show={pageLoading}/>}

            <p className="section-subtitle" style={{ textAlign: 'center' }}>ATLANTIC</p>
            <h2 className="h2 section-title" style={{ textAlign: 'center' }}>MEAL REGISTRATION</h2>
            

            <div className="RegistrationContainer">
                <div className="multiStepContainer">
                    {/* <header>Registration form</header> */}

                    <div className="form-outer">
                        <form onSubmit={handleSubmit}>
                            <div className="page slide-page">
                                {/* <h2 style={{color: "red"}}>* Student Registration closed *</h2> */}
                                <div className="title">Student Details</div>
                                
                                <div className="studentDetailsFormContainer">
                                    <div className="">
                                        <div className="field">
                                            <div className={`label ${errors.studentshool ? 'label-error' : ''} required`}>Select School</div>

                                            <select
                                                name="studentshool"
                                                value={formData.studentshool}
                                                onChange={handleSchoolChange}
                                                className={errors.studentshool ? 'input-error' : ''}
                                            >
                                                <option defaultValue>Select School</option>
                                                {loading ? (
                                                    <option disabled>Loading...</option>
                                                ) : (
                                                    
                                                    schools.map((school,index) => (
                                                        <option key={index} value={index}>
                                                            {school.school}
                                                        </option>
                                                    ))
                                                )}
                                            </select>

                                        </div>

                                        <div className="field">
                                            <div className={`label ${errors.studentSection ? 'label-error' : ''} required`}>Select Section</div>
                                            <select name="studentSection" value={formData.studentSection} onChange={handleChange} className={errors.studentSection ? 'input-error' : ''}>
                                                <option value="">Select Section</option>
                                                <option value="Infant">Infant</option>
                                                <option value="Junior">Junior</option>
                                                <option value="Secondary">Secondary</option>
                                            </select>
                                        </div>

                                        <div className="field">
                                            <div className={`label ${errors.studentClass ? 'label-error' : ''} required`}>Child's Class</div>

                                            <select
                                                name="studentClass"
                                                value={formData.studentClass}
                                                onChange={handleChange}
                                                className={errors.studentClass ? 'input-error' : ''}
                                                disabled={!formData.studentSection}
                                            >
                                                <option value="">Select Class</option>
                                                {classesBySection[formData.studentSection]?.map((classOption, index) => (
                                                    <option key={index} value={classOption}>
                                                        {classOption}
                                                    </option>
                                                ))}
                                            </select>
                                            {/* <input type="text" name='studentClass' value={formData.studentClass} onChange={handleChange}/> */}
                                        </div>

                                        <div className="field">
                                            <div className={`label ${errors.schoolTerm ? 'label-error' : ''} required`}>Select Term</div>
                                            <select
                                                name="schoolTerm"
                                                value={formData.schoolTerm}
                                                onChange={handleChange}
                                                className={errors.schoolTerm ? 'input-error' : ''}
                                            >
                                                <option defaultValue>Select Term</option>
                                                {
                                                    terms.map((term,index) => (
                                                        <option key={index} value={index}>
                                                            {term.term}
                                                        </option>
                                                    ))
                                                }
                                            </select>
                                        </div>

                                        
                                        {/* <div className="field">
                                            <div className={`label ${errors.studentDateOfBirth ? 'label-error' : ''} required`}>Date of birth</div>
                                            <input type="date" name="studentDateOfBirth" value={formData.studentDateOfBirth} onChange={handleChange} className={errors.studentDateOfBirth ? 'input-error' : ''} />
                                        </div> */}


                                    </div>

                                    <div className="">
                                        {/* SELECT SCHOOL */}
                                        <div className="field">
                                            <div className={`label ${errors.studentName ? 'label-error' : ''} required`}>Student Name</div>
                                            <input type="text" name="studentName" value={formData.studentName} onChange={handleChange} className={errors.studentName ? 'input-error' : ''} />
                                        </div>

                                        <div className="field">
                                            <div className={`label ${errors.studentID ? 'label-error' : ''} required`}>Student ID</div>
                                            <input type="text" name="studentID" value={formData.studentID} onChange={handleChange} className={errors.studentID ? 'input-error' : ''} />
                                        </div>

                                        <div className="field">
                                            <div className={`label ${errors.studentFoodAllergy ? 'label-error' : 'required'}`}>Any food allergy / dietary restriction?</div>
                                            <div className='allergyFields'>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="showAllergyDetails"
                                                        value="yes"
                                                        checked={showAllergyDetails === 'yes'}
                                                        onChange={() => handleRadioChange('yes')}
                                                    />
                                                    Yes
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="showAllergyDetails"
                                                        value="no"
                                                        checked={showAllergyDetails === 'no'}
                                                        onChange={() => handleRadioChange('no')}
                                                    />
                                                    No
                                                </label>
                                            </div>
                                        </div>

                                        {showAllergyDetails === 'yes' && (
                                            <div className="field">
                                                <div className={`label ${errors.studentFoodAllegy ? 'label-error' : ''}`}>Food Allergy</div>
                                                <input
                                                    type="text"
                                                    name="studentFoodAllegy"
                                                    value={formData.studentFoodAllegy}
                                                    onChange={handleChange}
                                                    className={errors.studentFoodAllegy ? 'input-error' : ''}
                                                />
                                            </div>
                                        )}

                                        {/* <div className="field">
                                            <div className={`label ${errors.studentFoodAllegy ? 'label-error' : ''} `}>Food Allergy</div>
                                            <input type="text" name="studentFoodAllegy" value={formData.studentFoodAllegy} onChange={handleChange} className={errors.studentFoodAllegy ? 'input-error' : ''} />
                                        </div> */}


                                    </div>                  
                                </div>

                                <div className="payrentFormContainer">
                                    <div className="title">Parent Information</div>
                                        <div className="flex-container">
                                            <div className="left-container">
                                                <div className="field">
                                                    <div className={`label ${errors.parentFullname ? 'label-error' : ''} required`}>Full Name</div>
                                                    <input type="text" name="parentFullname" value={formData.parentFullname} onChange={handleChange} className={errors.parentFullname ? 'input-error' : ''} />
                                                </div>
                                                <div className="field">
                                                    <div className={`label ${errors.parentNumber ? 'label-error' : ''} required`}>Phone Number</div>
                                                    <input type="number" name="parentNumber" value={formData.parentNumber} onChange={handleChange} className={errors.mobileNumber ? 'input-error' : ''} />
                                                </div>
                                            </div>

                                            <div className="right-container">
                                                <div className="field">
                                                    <div className={`label ${errors.parentEmail ? 'label-error' : ''} required`}>Email</div>
                                                    <input type="email" name="parentEmail" value={formData.parentEmail} onChange={handleChange} className={errors.email ? 'input-error' : ''} />
                                                </div>

                                                <div className="field">
                                                    <div className={`label ${errors.paymentType ? 'label-error' : ''} required`}>Payment Type</div>
                                                    <select name="paymentType" value={formData.paymentType} onChange={handleChange} className={errors.paymentType ? 'input-error' : ''}>
                                                        <option value="">Select Payment Type</option>
                                                        <option value="Mobile Money">Mobile Money</option>
                                                        <option value="Card Payment">Card Payment</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="field btns" style={{ margin: '0 auto' }}>
                                            {
                                                loading ? (<ClipLoader
                                                    color={"hsl(118, 45%, 51%)"}
                                                    cssOverride={override}
                                                    loading={loading}
                                                    size={50}
                                                    aria-label="Loading Spinner"
                                                    data-testid="loader"
                                                />) : <>
                                                    <button  type="submit" className="next-1 next">Make Payment</button>
                                                </>
                                            }
                                            
                                        </div>
                                        {/* {Object.values(errors).map((error, index) => (
                                            <ul>
                                                <li>
                                                    <p key={index} className="error">{error}</p>
                                                </li>
                                            </ul>
                                        ))} */}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MultiStepForm;
